import { getGeneralProjectTotalPages } from './generalProjectPagination';

export const SHIPPING_SCHEDULE_CONTRACT = { response: { envelope: [], includeMappedKeys: false } };

// Temporarily load only the first two pages; full-schedule data is keyed by project ID.
export const fetchShippingSchedulePages = async (fetchPage) => {
  const rows = new Map();
  let totalPages = 1;
  for (let page = 1; page <= totalPages; page += 1) {
    const result = await fetchPage(page);
    if (result.error) return { error: result.error };
    const payload = result.data;
    totalPages = Math.min(2, Math.max(totalPages, getGeneralProjectTotalPages(payload?.pagination ?? payload?.Pagination)));
    const data = payload?.data ?? payload?.Data ?? payload ?? {};
    const entries = Array.isArray(data) ? data : Object.values(data);
    entries.forEach((entry) => {
      const project = entry?.GeneralProjectInfo ?? entry?.generalProjectInfo ?? entry;
      const id = project?.ID ?? project?.Id ?? project?.ProjectId ?? project?.ProjectID;
      if (id != null) rows.set(String(id), entry);
    });
  }
  return { data: [...rows.values()] };
};
